import React, { useState } from 'react';
import FloatingChatButton from './FloatingChatButton';
import FloatingChatWindow from './FloatingChatWindow';
import './chat.css';
import Draggable from 'react-draggable';

const FloatingChat = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Draggable>
      <div className="floating-chat-container">
        {isOpen ? (
          <FloatingChatWindow onClose={toggleChat} />
        ) : (
          <FloatingChatButton onClick={toggleChat} />
        )}
      </div>
    </Draggable>
  );
};

export default FloatingChat;
